module.exports = __webpack_public_path__ + "static/media/17.Paint Mixer.3f2e474b.jpeg";